import { useGetFrameworkAgreementQuery, useGetSourcingEventQuery } from "../../../../../../autogen/bff-api";

export const useSettledTerms = (frameworkAgreementId: string | null) => {
  const { data: framework } = useGetFrameworkAgreementQuery(
    { frameworkAgreementId: frameworkAgreementId ?? "" },
    { skip: !frameworkAgreementId },
  );
  const { data: originatingEvent } = useGetSourcingEventQuery(
    { eventId: framework?.sourcingEventId ?? "" },
    { skip: !framework?.sourcingEventId },
  );

  if (!framework) return null;
  if (!framework.sourcingEventId) {
    return { framework, registeredByHand: true, qualificationCriteriaCount: 0, minimumRequirementCount: 0 } as const;
  }
  if (!originatingEvent) return null;
  return {
    framework,
    registeredByHand: false,
    qualificationCriteriaCount: originatingEvent.eventData.selectionCriteria.length,
    minimumRequirementCount: originatingEvent.eventData.minimumRequirements.length,
  } as const;
};
